export const environment = {
  baseUrl: 'https://api.winktienda.com/',
  url: 'https://chat.winktienda.com/',
  landing_page_url: 'https://usawink.com',
  urlWebSocket: 'wss://api.winktienda.com/',
};
